import { createContext } from 'react';

const EsContext = createContext();

export default EsContext;